import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { PayrollRecord, CreatePayrollRequest } from '../types';

export const payrollService = {
  getAll: async (): Promise<PayrollRecord[]> => {
    const response = await apiClient.get<PayrollRecord[]>(API_ENDPOINTS.PAYROLL.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<PayrollRecord> => {
    const response = await apiClient.get<PayrollRecord>(API_ENDPOINTS.PAYROLL.BY_ID(id));
    return response.data;
  },

  getByEmployee: async (employeeId: number): Promise<PayrollRecord[]> => {
    const response = await apiClient.get<PayrollRecord[]>(API_ENDPOINTS.PAYROLL.BY_EMPLOYEE(employeeId));
    return response.data;
  },

  getByPeriod: async (year: number, month: number): Promise<PayrollRecord[]> => {
    const response = await apiClient.get<PayrollRecord[]>(API_ENDPOINTS.PAYROLL.BY_PERIOD(year, month));
    return response.data;
  },

  getByYear: async (year: number): Promise<PayrollRecord[]> => {
    const response = await apiClient.get<PayrollRecord[]>(API_ENDPOINTS.PAYROLL.BY_YEAR(year));
    return response.data;
  },

  create: async (data: CreatePayrollRequest): Promise<PayrollRecord> => {
    const response = await apiClient.post<PayrollRecord>(API_ENDPOINTS.PAYROLL.BASE, data);
    return response.data;
  },

  update: async (id: number, data: CreatePayrollRequest): Promise<PayrollRecord> => {
    const response = await apiClient.put<PayrollRecord>(API_ENDPOINTS.PAYROLL.BY_ID(id), data);
    return response.data;
  },

  submit: async (id: number): Promise<PayrollRecord> => {
    const response = await apiClient.post<PayrollRecord>(API_ENDPOINTS.PAYROLL.SUBMIT(id));
    return response.data;
  },

  approve: async (id: number): Promise<PayrollRecord> => {
    const response = await apiClient.post<PayrollRecord>(API_ENDPOINTS.PAYROLL.APPROVE(id));
    return response.data;
  },

  markAsPaid: async (id: number): Promise<PayrollRecord> => {
    const response = await apiClient.post<PayrollRecord>(API_ENDPOINTS.PAYROLL.PAY(id));
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.PAYROLL.BY_ID(id));
  },
};
